import classNames from 'classnames';
import { type FC } from 'react';
import type { Props as IndexedBrandsProps } from 'src/components/pages/brands/BrandList';

type Props = IndexedBrandsProps & { isActive: boolean; onClick: () => void };

export const BrandList: FC<Props> = ({ brands, isActive, onClick }) => {
  const brandIndex = Object.keys(brands)[0];

  return (
    <li
      className={classNames(
        'w-7 h-7 flex justify-center items-center text-darkSlate border border-solid border-darkSlate rounded-mini cursor-pointer',
        'hover:bg-gray900 hover:text-white transition duration-300',
        isActive ? 'text-white bg-gray900' : ''
      )}
      onClick={onClick}
    >
      <span>{brandIndex}</span>
    </li>
  );
};
